(() => {
  function init(root) {
    if(root.dataset.ncjgReady) return;
    root.dataset.ncjgReady='true';
    root.addEventListener('click',event=>{
      const card=event.target.closest('.shade-card[data-ncjg-variant-id]');
      if(!card||!root.contains(card)||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      const productArea=root.closest('[data-product-featured]')||root.closest('.shopify-section');
      const form=productArea&&productArea.querySelector('form[data-type="add-to-cart-form"]');
      if(form){
        const swatch=Array.from(form.querySelectorAll('[data-swatch-option][data-id="0"] [data-swatch-item]')).find(item=>item.dataset.value===card.dataset.ncjgShade);
        if(swatch){swatch.click();}
        else{
          const nativeSelect=form.querySelector('select[name="id"]');
          if(nativeSelect&&Array.from(nativeSelect.options).some(option=>option.value===card.dataset.ncjgVariantId)){
            nativeSelect.value=card.dataset.ncjgVariantId;
            nativeSelect.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
      }
      const target=form||document.getElementById('ncjg-product');
      if(target){
        const top=Math.max(0,target.getBoundingClientRect().top+window.scrollY-100);
        window.scrollTo({top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
    });
    root.querySelectorAll('.makeup-comparison').forEach(comparison=>{
      const range=comparison.querySelector('.comparison-range');
      const before=comparison.querySelector('.comparison-label-before');
      const after=comparison.querySelector('.comparison-label-after');
      let pointer=null;
      function render(){const value=Number(range.value);comparison.style.setProperty('--reveal',value+'%');range.setAttribute('aria-valuetext',value+'% before makeup, '+(100-value)+'% with makeup');before.style.opacity=value>15?'1':'0';after.style.opacity=value<85?'1':'0';}
      function move(event){const box=comparison.getBoundingClientRect();range.value=String(Math.round(Math.max(0,Math.min(100,(event.clientX-box.left)/box.width*100))));render();}
      range.addEventListener('input',render);
      range.addEventListener('pointerdown',event=>{if(!event.isPrimary||(event.pointerType==='mouse'&&event.button!==0))return;event.preventDefault();pointer=event.pointerId;range.focus({preventScroll:true});range.setPointerCapture(pointer);move(event);});
      range.addEventListener('pointermove',event=>{if(event.pointerId===pointer)move(event);});
      function stop(event){if(event.pointerId!==pointer)return;pointer=null;if(range.hasPointerCapture(event.pointerId))range.releasePointerCapture(event.pointerId);}
      range.addEventListener('pointerup',stop);range.addEventListener('pointercancel',stop);range.addEventListener('lostpointercapture',()=>{pointer=null;});render();
    });
  }
  document.querySelectorAll('[data-ncjg-details]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ncjg-details]').forEach(init));
})();
